export const UserAbstractState = {
	url: '/user',
	abstract: true,
	redirectTo: 'user.auth',
	template: '<user-abstract-page></user-abstract-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "userAbstractPageMod" */
			'@Containers/user-abstract-page/user-abstract-page.cmp.js'
		)
			.then(m => $ocLazyLoad.load({name: m.default}))
			.catch(err => $log.error(err));
	},
};
